angular
    .module('dealerware.web.data')
    .factory('DealerwareAdditionalDriverModel', ['Model', '$dealerwareInternationalizationDateFormats', function (Model, $dealerwareInternationalizationDateFormats) {
        var model = new Model({
            baseEndpoint: '/locations/:location_id/reservations/:reservation_id/additional_drivers',
            customActions: {
                create: {
                    method: 'POST',
                    ignoreAssociations: true
                },
                delete: {
                    method: 'DELETE',
                    endpoint: '/locations/:location_id/reservations/:reservation_id/additional_drivers/:id'
                },
                update: {
                    method: 'PUT',
                    endpoint: '/locations/:location_id/reservations/:reservation_id/additional_drivers/:id',
                    ignoreDefaultRootNodeResponse: true,
                    ignoreAssociations: true
                }
            },
            requestTransforms: {
                create: formatDate,
                update: formatDate
            }
        });

        function formatDate(_, data) {
            data.date_of_birth = $dealerwareInternationalizationDateFormats.parseDateForRequest(data.date_of_birth, 'YYYY-MM-DD');
            data.drivers_license_expiration = $dealerwareInternationalizationDateFormats.parseDateForRequest(data.drivers_license_expiration, 'YYYY-MM-DD');
        }
        
        jQuery.extend(model.prototype, {});
        return model;
}]);